export const listingDict = {
  com: 'Commercial',
  farm: 'Farm',
  land: 'Land',
  mob: 'MobileHome',
  mult: 'Multifamily',
  rnt: 'Rental',
  res: 'Residential',
};

export const listingRuleDict = {
  com: 'CommercialListingRules',
  farm: 'FarmListingRules',
  land: 'LandListingRules',
  mob: 'MobileHomeListingRules',
  mult: 'MultifamilyListingRules',
  rnt: 'RentalListingRules',
  res: 'ResidentialListingRules',
  chgTerm: 'ChangeToTerminatedListingRules',
  chgSold: 'ChangeToSoldListingRules',
  chgMajor: 'MajorCorrectionsRules',
  chgPending: 'ChangeToPendingListingRules',
  chgLeased: 'ChangeToLeasedListingRules',
  chgWithdrawn: 'ChangeToWithdrawnListingRules',
  chgActive: 'ChangeToActiveListingRules',
  chgExp: 'ChangeToExpiredListingRules',
  chgDel: 'ChangeToDeletedListingRules',
  chgOpenHouse: 'ChangeToOpenHouseListingRules',
};
